var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHansum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 142,
    viewBox: "0 0 161 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEC\x9D\xB8 \xEC\x8B\xAC\xEB\xB3\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6819 142C8.09582 142 5.50484 141.056 3.47775 139.149C-0.707683 135.21 -0.872962 128.65 3.10344 124.504C28.1625 98.3876 28.1625 57.477 3.10344 31.3607C-0.872962 27.2143 -0.707683 20.6599 3.47775 16.7157C7.66318 12.7715 14.2792 12.9401 18.2604 17.0865C51.005 51.2068 51.005 104.658 18.2604 138.773C16.2042 140.916 13.4479 141.995 10.6819 141.995V142Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M149.707 142C146.941 142 144.185 140.921 142.129 138.778C109.384 104.658 109.384 51.2069 142.129 17.0866C146.105 12.9402 152.726 12.7764 156.911 16.7158C161.097 20.6552 161.262 27.2143 157.286 31.3608C132.222 57.4771 132.222 98.3877 157.286 124.504C161.262 128.65 161.097 135.205 156.911 139.149C154.889 141.056 152.298 142 149.707 142Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.6013 78.4838C56.7964 78.4838 37.9206 71.1589 26.1761 64.9321C20.7608 62.0618 18.7191 55.3822 21.6212 50.0174C24.5185 44.6525 31.2609 42.6299 36.6762 45.5049C46.379 50.6531 62.1047 56.721 81.9575 56.4417C100.265 56.1768 114.819 50.5568 123.812 45.8854C129.251 43.0585 135.974 45.1389 138.828 50.5279C141.681 55.9168 139.581 62.5771 134.142 65.404C118.178 73.6969 100.24 78.219 82.2832 78.479C81.7242 78.4887 81.1652 78.4935 80.611 78.4935L80.6013 78.4838Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.0079 24.609C62.0713 24.609 66.176 19.1001 66.176 12.3045C66.176 5.5089 62.0713 0 57.0079 0C51.9445 0 47.8398 5.5089 47.8398 12.3045C47.8398 19.1001 51.9445 24.609 57.0079 24.609Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.379 24.609C108.442 24.609 112.547 19.1001 112.547 12.3045C112.547 5.5089 108.442 0 103.379 0C98.3156 0 94.2109 5.5089 94.2109 12.3045C94.2109 19.1001 98.3156 24.609 103.379 24.609Z",
    fill: "#25569D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHansum);
export default __webpack_public_path__ + "static/media/hansum.4be27a11f6b0021c62d727951505572e.svg";
export { ForwardRef as ReactComponent };